export enum FlowStatus {
    PREPARATION = 1,
    EXPEDITED = 2,
    DELIVERED = 3
}

